import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './drawer.scss';

class Drawer extends Component {
    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,
        children: PropTypes.node,
        title: PropTypes.string,
        position: PropTypes.oneOf(['left', 'right']),
    };

    static defaultProps = {
        position: 'right',
    };

    componentDidMount() {
        this.updateBodyOverflow();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isOpen !== this.props.isOpen) {
            this.updateBodyOverflow();
        }
    }

    componentWillUnmount() {
        document.body.classList.remove('drawer-open');
    }

    updateBodyOverflow = () => {
        if (this.props.isOpen) {
            document.body.classList.add('drawer-open');
        } else {
            document.body.classList.remove('drawer-open');
        }
    };

    render() {
        const { isOpen, onClose, children, title, position } = this.props;

        return (
            <div>
                <div className={`drawer-backdrop ${isOpen ? 'visible' : ''}`} onClick={onClose}></div>
                <div className={`drawer-container drawer-${position} ${isOpen ? 'open' : ''}`}>
                    <div className="drawer-header">
                        <button className="drawer-close-btn" onClick={onClose}>
                            <i class="fa fa-chevron-left" aria-hidden="true"></i>
                        </button>
                        <h2 className="drawer-title">{title}</h2>
                    </div>
                    <div className="drawer-content">
                        {children}
                    </div>
                </div>
            </div>
        );
    }
}

export default Drawer;


// WEBPACK FOOTER //
// ./src/components/Drawer/Drawer.js